import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "central-background" }
const _hoisted_2 = { class: "py-0 d-flex justify-content-center third-level-nav" }
const _hoisted_3 = { class: "horizontal-nav-bar rounded-top" }
const _hoisted_4 = {
  class: "d-flex bg-white rounded-top",
  id: "solution-tab",
  role: "tablist",
  "aria-orientation": "horizontal"
}
const _hoisted_5 = ["id", "disabled", "onClick"]
const _hoisted_6 = { class: "d-flex justify-content-start ms-auto py-2 px-3" }
const _hoisted_7 = {
  class: "tab-content",
  id: "v-pills-tabContent"
}
const _hoisted_8 = { class: "px-3 mb-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FrequencyWatchHos = _resolveComponent("FrequencyWatchHos")!
  const _component_FrequencyWatchHH = _resolveComponent("FrequencyWatchHH")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("a", {
                class: _normalizeClass(`nav-link d-flex justify-content-between align-items-center ${
                                _ctx.activeTab === tab.id ? 'active' : ''
                            } ${!_ctx.allowedTabs.includes(tab.id) || !tab.show ? 'disabled-tab' : ''}`),
                id: `v-pills-${tab.id}`,
                "data-toggle": "pill",
                href: "javascript:void(0)",
                role: "tab",
                key: tab.id,
                "aria-selected": "true",
                disabled: !_ctx.allowedTabs.includes(tab.id) || !tab.show,
                onClick: ($event: any) => (_ctx.handleTabChange(tab))
              }, _toDisplayString(tab.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToReportCenter()))
              }, " Report Center ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("section", _hoisted_8, [
            (_ctx.activeTab === _ctx.ApplicationEnum.AxxessHospiceFE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_FrequencyWatchHos, {
                    application: _ctx.ApplicationEnum.AxxessHospiceFE,
                    "get-frequency-watch-data": _ctx.getFrequencyWatchData
                  }, null, 8 /* PROPS */, ["application", "get-frequency-watch-data"])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.activeTab === _ctx.ApplicationEnum.AgencyCore)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_FrequencyWatchHH, {
                    application: _ctx.ApplicationEnum.AgencyCore,
                    "get-frequency-watch-data": _ctx.getFrequencyWatchData
                  }, null, 8 /* PROPS */, ["application", "get-frequency-watch-data"])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ]))
}